import React from "react";
import PropTypes from "prop-types"; // Import PropTypes
import { base_path } from "../../environment";
const ImageWithBasePath = ({ src, alt, ...rest }) => {
  // Combine the base path and the provided src to create the full image source URL
  const isAbsolute = src && (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('blob:') || src.startsWith('data:'));
  const fullSrc = isAbsolute ? src : `${base_path}${src}`;

  // Ensure alt is always a string, default to empty string if not
  const validAlt = typeof alt === 'string' ? alt : "";

  return (
    <img
      src={fullSrc}
      alt={validAlt}
      {...rest}
    />
  );
};

// Add PropTypes validation
ImageWithBasePath.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired, // Make 'src' required
  alt: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  id: PropTypes.string,
};

export default ImageWithBasePath;
